import React from 'react'
import Navigation from '../layout/Navigation'

const About = () => {
    return (
        <>
            <Navigation title="Raunak Kesarwani" />
        </>
    )
}

export default About;